import { showInfo } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

export const SET_PODCASTS_DATA = 'SET_PODCASTS_DATA';
const setPodcastsData = (podcastsData, proContentLoaded) => ({
    type: SET_PODCASTS_DATA,
    data: {
        podcastsData,
        proContentLoaded,
    },
});

export const SET_CURRENT_PODCAST_SHOW = 'SET_CURRENT_PODCAST_SHOW';
const addCurrentPodcastShow = (podcastType) => ({
    type: SET_CURRENT_PODCAST_SHOW,
    data: podcastType,
});

export const SET_PODCAST_EPISODES = 'SET_PODCAST_EPISODES';
const setPodcastEpisodes = (podcastEpisodes) => ({
    type: SET_PODCAST_EPISODES,
    data: podcastEpisodes,
});

export const SET_IS_LOADING_NEWS = 'SET_IS_LOADING_NEWS';
const setIsLoadingNews = (isLoading) => ({
    type: SET_IS_LOADING_NEWS,
    isLoading,
});

export const SET_LOADING_TEXT = 'SET_LOADING_TEXT';
export const setLoadingText = (loadingText) => ({
    type: SET_LOADING_TEXT,
    loadingText,
});

export const getPodcastEpisodes = (podcastType, init, num) => (dispatch, getState) => {
    const query = `api/v1/getPodcastEpisodes/${podcastType}/${init}/${num}`;
    const { podcastEpisodes } = getState().podcasts.simplecastPodcasts;

    dispatch(setIsLoadingNews(true));

    dispatch(setLoadingText(''));

    return Api.progressGet(dispatch, query)
        .then((json) => {
            dispatch(setIsLoadingNews(false));

            if (json.status !== 'success') {
                throw `error from server: ${json.message}`;
            } else if (json.data.length < num) {
                podcastEpisodes.length !== 0 && showInfo(json.message);

                dispatch(setPodcastEpisodes(json.data));

                dispatch(setLoadingText('- - -'));
            } else {
                dispatch(setPodcastEpisodes(json.data));
            }
        }).catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
};

export const setCurrentPodcastShow = (podcastType) => (dispatch, getState) => {
    const previousPodcastType = getState().podcasts.currentPodcastShow;

    if (podcastType !== previousPodcastType) {
        dispatch(addCurrentPodcastShow(podcastType));
    }

    const { podcastEpisodes } = getState().podcasts.simplecastPodcasts;

    if (podcastEpisodes.length === 0) {
        dispatch(getPodcastEpisodes(podcastType, 0, 20));
    }
};

export const getPodcastsDataIfNeeded = (currentSlug, isPro) => (dispatch, getState) => {
    // check if we already have the podcasts data, if not get it
    // if currentSlug is given set the current show
    // if isPro is true, try to fetch the PRO content (currently only the showId of PRO podcasts...)

    const currentPodcastsData = getState().podcasts.simplecastPodcasts.podcastsData;
    const proContentLoaded = getState().podcasts.simplecastPodcasts.proContentLoaded;

    if (currentPodcastsData.length === 0 || (isPro && !proContentLoaded)) {
        const token = getState().profile.jwt;

        if (isPro && !token) {
            return Promise.resolve(1);
        }

        let query = 'api/v1/getPodcastsData';

        if (isPro) {
            query = 'api/v1/getProPodcastsData';
        }

        dispatch(setIsLoadingNews(true));

        return Api.progressGet(dispatch, query, token)
            .then((json) => {
                dispatch(setIsLoadingNews(false));

                if (json.status !== 'success') {
                    throw `error from server:${json.message}`;
                } else {
                    // promise all!
                    const allPodcasts = json.data;
                    const myPromises = [];

                    myPromises.push(dispatch(setPodcastsData(allPodcasts, isPro)));

                    if (currentSlug) {
                        // we are on a podcast single page, set the data
                        const podcastData = allPodcasts.find((podcast) => podcast.slug === currentSlug);

                        if (podcastData) {
                            myPromises.push(dispatch(setCurrentPodcastShow(podcastData.type)));
                        } else {
                            throw `podcast not found: ${currentSlug}`;
                        }
                    }

                    return Promise.all(myPromises);
                }
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.log('getPodcastsDataIfNeeded got error:', err);
            });
    }

    if (currentSlug) {
        // update the current podcast data, if necessary
        const podcastData = currentPodcastsData.find((podcast) => podcast.slug === currentSlug);

        if (podcastData) {
            return dispatch(setCurrentPodcastShow(podcastData.type));
        }

        // eslint-disable-next-line no-console
        console.error('something went wrong getting the podcast data');
    }

    return Promise.resolve(1);
};
